import React, { useMemo } from "react";
import { classNames } from "@greeter/util";

import css from "./Input.module.scss";

type Props = React.PropsWithChildren &  {
  detectChanges?: boolean;
  initialValue?: string;
  hasChanged?: boolean;
  beforeSlot?: React.ReactNode;
  afterSlot?: React.ReactNode;
} & React.HTMLProps<HTMLInputElement>;

const Input: React.FC<Props> = ({
  className,
  detectChanges = false,
  hasChanged = false,
  beforeSlot,
  afterSlot,
  initialValue,
  value,
  ...props
}) => {
  const internalHasChanged = useMemo(
    () => hasChanged || (detectChanges && initialValue && initialValue !== value),
    [detectChanges, initialValue, value, hasChanged]
  );

  return (
    <div className={css.InputContainer}>
      {beforeSlot}
      <input
        value={value}
        {...props}
        {...classNames(css.Input, className, internalHasChanged ? css.Changed : "")}
      />
      {afterSlot}
    </div>
  );
};

export default Input;
export type { Props as InputProps };
